// src/globalAxiosInterceptor.js
//
// Registers ONE response interceptor on the default axios instance,
// installed at true app entry (imported first thing in index.js, before
// React even renders). This runs for EVERY plain `axios.get/post/...`
// call anywhere in the app that uses the default import.
//
// If a 401 comes back from ANY endpoint, this forces a clean logout
// rather than leaving the app in a half-authenticated state.

import axios from 'axios';

let installed = false;

export function installGlobalAxiosInterceptor() {
  if (installed) return; // guard against double-install (e.g. React StrictMode)
  installed = true;

  axios.interceptors.response.use(
    (response) => response, // pass successful responses through untouched
    (error) => {
      const status = error?.response?.status;

      if (status === 401) {
        console.error('[globalAxiosInterceptor] 401 — forcing logout.', error?.config?.url);
        localStorage.removeItem('sessionData');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('token');
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }

      return Promise.reject(error);
    }
  );
}